import React, { useState } from "react";
import { footerWrapCss, footerCenterBoxCss } from "./Footer.style";
import { HiOutlineMail } from "react-icons/hi";
import {Link} from "react-router-dom";
import {useIsMobile} from "../../../hooks/useIsMobile";
import BookmeetIntro from "@/common/layouts/footer/BookmeetIntro";


const Footer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const isMobile = useIsMobile();
    const onOpen = () => setIsOpen(!isOpen);
    return (
        <footer css={footerWrapCss} className="px-4 py-10 lg:py-16">
            <a href="/" className="footerLogo mt-10 lg:mt-[81px]">
                <img src="/footer_logo2.svg" alt="logo" className="h-8 lg:h-10 mx-auto" />
            </a>

            {isMobile ? (
                <>
                    <div className="flex flex-col mt-8 w-full">
                        <div className="flex flex-col mb-6 w-full">
                            <ul className="m-0 p-0 flex flex-wrap justify-center items-center gap-x-2.5 gap-y-2">
                                <li className="text-white text-[11px] font-semibold">
                                    <Link to="/bookmeetIntro" className="text-white hover:text-main transition-colors">회사 소개</Link>
                                </li>
                                <span className="text-white/20 text-[9px] select-none">|</span>
                                <li className="text-white text-[11px] font-semibold">
                                    <Link to="/policy/terms" className="text-white hover:text-main transition-colors">이용약관</Link>
                                </li>
                                <span className="text-white/20 text-[9px] select-none">|</span>
                                <li className="text-white text-[11px] font-semibold">
                                    <Link to="/policy/privacy" className="text-white hover:text-main transition-colors">개인정보 처리 방침</Link>
                                </li>
                                <span className="text-white/20 text-[9px] select-none">|</span>
                                <li className="text-white text-[11px] font-semibold">
                                    <Link to="/policy/youth" className="text-white hover:text-main transition-colors">청소년보호정책</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="flex flex-col gap-2.5 items-center text-center w-full text-[#959AAB] text-[10px] leading-relaxed">
                            <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1">
                                <span className="font-medium text-white/90">서림 (書林)</span>
                                <span className="text-white/20 text-[9px] select-none">|</span>
                                <span>대표자 : 하서빈</span>
                                <span className="text-white/20 text-[9px] select-none">|</span>
                                <span>사업자등록번호: 872-22-01987</span>
                            </div>
                            <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1">
                                <span>대표 전화 : 010-7584-0863</span>
                                <span className="text-white/20 text-[9px] select-none">|</span>
                                <span>with.bookmeet@gmail.com</span>
                            </div>
                            <div className="max-w-[320px] sm:max-w-none break-keep opacity-80 mt-1">
                                주소 : 서울특별시 송파구 가락로 15길 14, 501호(석촌동)
                            </div>
                        </div>

                        <div className="w-full flex flex-col justify-center items-center gap-3 mt-8">
                            <div className="w-full max-w-[340px] border-t border-white/10"></div>
                            <p className="text-[#959AAB] text-[10px] font-normal opacity-60">Ⓒ 북밋. All right reserved.</p>
                        </div>
                    </div>
                </>
            ) : (
                <div className="flex flex-col mt-[35px] w-full items-center">
                    <ul className="m-0 p-0 flex flex-row justify-center items-center gap-2">
                        <li className="text-white text-base font-semibold">
                            <Link to="/bookmeetIntro" className="text-white hover:text-main transition-colors">회사 소개</Link>
                        </li>
                        <div className="w-[1px] h-[17.5px] bg-white/20 my-[14px] mx-[3px]"></div>
                        <li className="text-white text-base font-semibold">
                            <Link to="/policy/terms" className="text-white hover:text-main transition-colors">이용약관</Link>
                        </li>
                        <div className="w-[1px] h-[17.5px] bg-white/20 my-[14px] mx-[3px]"></div>
                        <li className="text-white text-base font-semibold">
                            <Link to="/policy/privacy" className="text-white hover:text-main transition-colors text-main font-bold">개인정보 처리 방침</Link>
                        </li>
                        <div className="w-[1px] h-[17.5px] bg-white/20 my-[14px] mx-[3px]"></div>
                        <li className="text-white text-base font-semibold">
                            <Link to="/policy/youth" className="text-white hover:text-main transition-colors">청소년보호정책</Link>
                        </li>
                    </ul>
                    <ul className="m-0 p-0 flex flex-row justify-center items-center gap-2 mt-4">
                        <li>
                            <span className="text-[#959AAB] text-sm font-normal">서림 (書林)</span>
                        </li>
                        <div className="w-[1px] h-[12px] bg-[#959AAB]/20 my-[14px] mx-[3px]"></div>
                        <li>
                            <span className="text-[#959AAB] text-sm font-normal">대표자 : 하서빈</span>
                        </li>
                        <div className="w-[1px] h-[12px] bg-[#959AAB]/20 my-[14px] mx-[3px]"></div>
                        <li>
                            <span className="text-[#959AAB] text-sm font-normal">주소 : 서울특별시 송파구 가락로 15길 14, 501호(석촌동)</span>
                        </li>
                    </ul>
                    <ul className="m-0 p-0 flex flex-row justify-center items-center gap-2 mt-2">
                        <li>
                            <span className="text-[#959AAB] text-sm font-normal">대표 전화 : 010-7584-0863</span>
                        </li>
                        <div className="w-[1px] h-[12px] bg-[#959AAB]/20 my-[14px] mx-[3px]"></div>
                        <li>
                            <span className="text-[#959AAB] text-sm font-normal">사업자등록번호: 872-22-01987</span>
                        </li>
                        <div className="w-[1px] h-[12px] bg-[#959AAB]/20 my-[14px] mx-[3px]"></div>
                        <li>
                            <span className="text-[#959AAB] text-sm font-normal">with.bookmeet@gmail.com</span>
                        </li>
                    </ul>

                    <div className="flex flex-col justify-center items-center gap-3 mt-8 w-full">
                        <div className="w-full max-w-[1200px] border-t border-white/10"></div>
                        <p className="text-[#959AAB] text-sm font-normal opacity-60 mt-2">Ⓒ 북밋. All right reserved.</p>
                    </div>
                </div>
            )}
        </footer>
    );
};

export default Footer;
